import React from "react";
import { PlaceholderMessage, SignatureGlyph } from "./styles";
import { Text } from "../../../text";
export var EmptySignatureMessage = function () { return (React.createElement(PlaceholderMessage, null,
    React.createElement(SignatureGlyph, { className: "image-placeholder-signature", alt: "Signature Placeholder" }),
    React.createElement(Text, { fontSize: 4 }, "Please use your finger to sign here."))); };
